export default {
      id: "mic-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#mic",
      toString: function () {
        return this.url;
      }
    }